
import { initializeApp } from "firebase/app";
import { getFirestore } from 'firebase/firestore';
import { getAuth } from "firebase/auth";
import 'firebase/auth'

const firebaseConfig = {
  apiKey: "AIzaSyCNl1kX3e8icWaAyfFV7rtWF9nX2TdyaoE",
  authDomain: "featurelive-5a98b.firebaseapp.com",
  projectId: "featurelive-5a98b",
  storageBucket: "featurelive-5a98b.appspot.com",
  messagingSenderId: "142782808871",
  appId: "1:142782808871:web:e57fd20647b6f481765f02",
  measurementId: "G-KLE7JVGNJW"
};

const app = initializeApp(firebaseConfig);

export const auth = getAuth();
const db = getFirestore(app);
export default db;
